import React, { useEffect } from 'react';
import HelpLayout from '../../../components/help/HelpLayout';

const AdminDashboardHelp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { name: 'Admin Guide', href: '/help/admin/dashboard' },
    { name: 'Admin Dashboard' }
  ];

  return (
    <HelpLayout title="Admin Dashboard Overview" breadcrumbs={breadcrumbs}>
      <div className="help-content">
        <div className="card">
          <div className="card-body">
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: 'var(--primary-black)',
              marginBottom: '16px'
            }}>
              Administrator Dashboard Guide
            </h2>
            <p style={{
              fontSize: '16px',
              color: 'var(--text-gray)',
              lineHeight: 1.6
            }}>
              Comprehensive overview of administrative features, key metrics, and quick actions for GCRA staff.
            </p>
            <div style={{
              padding: '24px',
              backgroundColor: 'var(--background-gray)',
              borderRadius: '8px',
              marginTop: '24px',
              textAlign: 'center'
            }}>
              <p style={{ color: 'var(--text-gray)', margin: 0 }}>
                🛡️ Administrative content coming soon...
              </p>
            </div>
          </div>
        </div>
      </div>
    </HelpLayout>
  );
};

export default AdminDashboardHelp;
